import { useState } from "react";
import loginLogo from "../assets/logiscreen.png";
// import backgroundImage from "../assets/First-7.png";
import { Link } from "react-router-dom";

const businessTypes = [
  "Retail", "Fast Food", "Whole Sale", "Services", "Restaurant", "Trader", "others"
];

const BusinessTypeSelection = () => {
  const [selectedType, setSelectedType] = useState("");

  const handleSelect = (type) => {
    setSelectedType(type);
  };

  return (
    <div className="h-screen w-screen overflow-hidden">

      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        {/* Left: Logo */}
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        {/* Right: Selection Box */}
        <div className="bg-white flex flex-col justify-center items-center p-2">
          <div className="bg-white w-full max-w-md rounded-3xl py-6 px-4">
            <h2 className="text-center text-xl font-semibold mb-4">
              Your <br /> <span className="font-bold">Business Type</span>
            </h2>
            <div className="grid grid-cols-2 gap-3 mb-4">
              {businessTypes.map((type, index) => (
                <button
                  key={index}
                  onClick={() => handleSelect(type)}
                  className={`py-2 rounded-full border text-sm transition-all ${
                    selectedType === type
                      ? "bg-[#C8102E] text-white border-[#C8102E]"
                      : "border-gray-300 text-gray-700 hover:border-red-400 hover:text-primary"
                  }`}
                >
                  {type}
                </button>
              ))}
            </div>
            <p className="text-xs text-red-500 text-center">
              Accept invite and join as Staff, Partner, or Manager
            </p>
            <div className="flex justify-end">
              <Link
                to="/signup"
                className="my-4 w-full text-center bg-[#C8102E] text-white py-2 px-4 rounded-md"
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden relative h-full w-full">
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0 w-full h-full"
          style={{
             backgroundImage: `url(${loginLogo})`,
            backgroundSize: "contain",
            backgroundPosition: "top center"

          }}
        />

        {/* Black overlay with 0.7 opacity */}
        <div className="absolute inset-0 bg-black opacity-30 z-0" />

        {/* Top: Logo and Heading */}
      

        {/* Bottom Popup / Modal */}
        <div className="absolute bottom-0 left-0 right-0 z-20 bg-white rounded-t-3xl px-6 pt-4 pb-6 shadow-2xl">
          {/* Handle bar */}
          <div className="w-14 h-1.5  rounded-full mx-auto mb-4" />

          {/* Title */}
          <h2 className="text-center text-lg font-semibold text-gray-800 mb-4">
            Your <br /> <span className="font-bold text-gray-900">Business Type</span>
          </h2>

          {/* Buttons */}
          <div className="grid grid-cols-2 gap-3 mb-4">
            {businessTypes.map((type, index) => (
              <button
                key={index}
                onClick={() => handleSelect(type)}
                className={`py-2 rounded-xl border text-sm transition-all ${
                  selectedType === type
                    ? "bg-[#C8102E] text-white border-[#C8102E]"
                    : "border-gray-300 text-gray-700 hover:border-red-400 hover:text-primary"
                }`}
              >
                {type}
              </button>
            ))}
          </div>

          {/* Bottom Info Message */}
          <p className="text-xs text-red-500 text-center bg-red-50 py-2 rounded">
            Accept Invite and Join as Staff, Partner, or Manager
          </p>

          {/* Optional Next Button */}
          <div className="flex justify-center mt-4">
            <Link
              to="/signup"
              className="bg-[#C8102E] text-white w-full text-center py-2 px-6 rounded-md text-sm"
            >
              Next
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessTypeSelection;
